/** 环境变量缺失时的兜底系统名称 */
const FALLBACK_APP_TITLE = '连云港汽车后市场综合服务平台'

/**
 * 解析有效系统名称，过滤空值与历史持久化缓存中的 "undefined"
 */
export function resolveAppTitle(title?: string | null): string {
  const normalized = (title ?? '').trim()
  if (!normalized || normalized === 'undefined') {
    const envTitle = (import.meta.env.VITE_APP_TITLE || '').trim()
    return envTitle || FALLBACK_APP_TITLE
  }
  return normalized
}

/**
 * 拼接浏览器窗口标题：有页面名时为「系统名 - 页面名」，否则仅系统名
 */
export function buildDocumentTitle(systemName: string, pageName?: string): string {
  const name = resolveAppTitle(systemName)
  const page = (pageName || '').trim()
  return page ? `${name} - ${page}` : name
}
